(() => {
  // ---- Safe config (works even if data-toot-config is missing) ----
  const CONFIG = (() => {
    const fallback = { words: ["toot"], tooltip: "Click me" };
    const el = document.querySelector("[data-toot-config]");
    if (!el) return fallback;

    try {
      const parsed = JSON.parse(el.textContent || "{}");
      const words =
        Array.isArray(parsed.words) && parsed.words.length
          ? parsed.words
          : (typeof parsed.words === "string" ? parsed.words.split(",") : fallback.words);

      return {
        words: words.map((w) => (w || "").trim()).filter(Boolean),
        tooltip: (parsed.tooltip || fallback.tooltip).trim(),
      };
    } catch (e) {
      console.warn("[TOOT] Invalid JSON in [data-toot-config]. Using fallback.", e);
      return fallback;
    }
  })();

  if (!CONFIG.words || !CONFIG.words.length) {
    console.warn("[TOOT] No trigger words. Exiting.");
    return;
  }

  // ---- Utilities ----
  const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "INPUT", "SELECT", "OPTION", "BUTTON", "SVG", "CANVAS"]);

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  const regex = new RegExp(`\\b(${CONFIG.words.map(escapeRegExp).join("|")})\\b`, "gi");

  function shouldSkip(node) {
    if (!node || !node.parentElement) return true;
    const p = node.parentElement;

    // don't wrap inside interactive things
    if (p.closest(".toot-word")) return true;
    if (p.closest("a, button, input, textarea, select, [contenteditable='true']")) return true;
    if (SKIP_TAGS.has(p.tagName)) return true;

    return false;
  }

  function wrapTextNode(node) {
    const text = node.nodeValue;
    if (!text || !regex.test(text)) return false;
    regex.lastIndex = 0;

    const frag = document.createDocumentFragment();
    let last = 0;
    let m;

    while ((m = regex.exec(text)) !== null) {
      const start = m.index;
      const end = start + m[0].length;

      if (start > last) frag.appendChild(document.createTextNode(text.slice(last, start)));

      const span = document.createElement("span");
      span.className = "toot-word";
      span.setAttribute("role", "button");
      span.setAttribute("tabindex", "0");
      span.dataset.tootTip = CONFIG.tooltip || "Click me";
      span.textContent = m[0];
      frag.appendChild(span);

      last = end;
    }

    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));

    node.parentNode.replaceChild(frag, node);
    return true;
  }

  function scanAndWrap(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
          const v = node.nodeValue;
          if (!v || !v.trim()) return NodeFilter.FILTER_REJECT;
          if (!regex.test(v)) return NodeFilter.FILTER_SKIP;
          regex.lastIndex = 0;
          return NodeFilter.FILTER_ACCEPT;
        },
      },
      false
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(wrapTextNode);
  }

  // ---- Animation trigger ----
  let busy = false;

  function restartClass(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  let tootAudio = null;

  function setupTootAudio() {
    const url = window.TOOT_AUDIO_URL;
    if (!url) return;
    tootAudio = new Audio(url);
    tootAudio.preload = "auto";
    tootAudio.volume = 0.85;
  }

  setupTootAudio();

  function playEffect() {
    if (busy) return;
    const overlay = document.querySelector("[data-toot-global]");
    if (!overlay) {
      console.warn("[TOOT] Overlay missing: [data-toot-global] not found.");
      return;
    }

    busy = true;

    // play fart sound
    window.setTimeout(() => {
      if (!tootAudio) return;
      try {
        tootAudio.currentTime = 0;
        tootAudio.play().catch(() => {});
      } catch (e) {}
    }, 500); // adjust: 120–250ms usually feels perfect

    // corner peek
    restartClass(overlay, "is-peeking");

    // puff
    window.setTimeout(() => {
      overlay.classList.add("is-puffing");
      window.setTimeout(() => overlay.classList.remove("is-puffing"), 950);
    }, 420);

    // smoke fill
    window.setTimeout(() => {
      overlay.classList.add("is-smoking");
      window.setTimeout(() => {
        overlay.classList.remove("is-smoking");
        overlay.classList.remove("is-peeking");
        busy = false;
      }, 1300);
    }, 650);

    window.setTimeout(() => (busy = false), 2400);
  }

  function onActivate(e) {
    const t = e.target.closest(".toot-word");
    if (!t) return;

    if (e.type === "keydown") {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
    }

    playEffect();
  }

  function init() {
    // wrap initial
    scanAndWrap(document.body);

    // wrap dynamic DOM updates
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1) scanAndWrap(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("click", onActivate, true);
    document.addEventListener("keydown", onActivate, true);

    // debug: how many wrapped
    console.log("[TOOT] Ready. Wrapped:", document.querySelectorAll(".toot-word").length, "Config:", CONFIG);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();